<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <h3 class="card-title"><i class="ti-face-smile"></i> {{ $t("Happy Meter") }}</h3></div>
        </div>
        <div class="table-responsive m-t-20" v-if="dataLoaded">
          <!-- Do not display the table on mobile-->
          <table class="table vm no-th-brd pro-of-month d-none d-sm-table" style="overflow: hidden">
            <tbody>
            <tr v-for="user in usersData">
              <td style="width:50px;">
                <span class="round">
                  <img :src="user.photo" alt="user" width="50" height="50">
                </span>
              </td>
              <td>
                <h6>{{ user.firstname }} {{ user.lastname }}</h6>
                <small class="text-muted">
                  {{ user.Units | unitFormatter }}
                </small>
              </td>
              <td >
                <div class="row">
                  <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'sad')">
                    <happy-meter-smileys :smiley-type="'sad'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
                  </div>
                  <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'neutral')">
                    <happy-meter-smileys :smiley-type="'neutral'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
                  </div>
                  <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'happy')">
                    <happy-meter-smileys :smiley-type="'happy'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <!-- Display it in a rowlike way -->
          <div v-for="user in usersData" class="d-sm-none">
            <div class="row user-name-row">
              <h6>{{ user.firstname }} {{ user.lastname }}</h6>
            </div>
            <div class="row">
              <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'sad')">
                <happy-meter-smileys :smiley-type="'sad'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
              </div>
              <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'neutral')">
                <happy-meter-smileys :smiley-type="'neutral'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
              </div>
              <div class="col-4" id="disable-it" v-on:click="changeSmiley(user.uid, 'happy')">
                <happy-meter-smileys :smiley-type="'happy'" :userid="user.uid" :initial-value="user.happy_value"></happy-meter-smileys>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  import HappyMeterSmileys from "./HappyMeterSmileys";

  export default {
    components: {HappyMeterSmileys},
    props: {
      attendees: {
        default: []
      },
      meeting: {
        default: 0
      }
    },
    name: "happy-meter-widget",
    data: function () {
      return {
        usersData: [],
        userHappy: {},
        meeting_uid: this.meeting,
        classes: "btn btn-primary",
        dataLoaded: false
      }
    },
    created() {

    },
    mounted() {
      this.usersData = JSON.parse(JSON.stringify(this.attendees));
      this.userHappy = {};
      this.getUserData();
    },
    methods: {
      getUserData() {
        if (this.userData === undefined) {
          apiHelper.getResource("/api/tool/happymeter/" + this.meeting_uid).then((data) => {
            this.usersData = data;
            this.parseUsers();
          });
        } else if (!(this.userData.length > 0 && (Object.keys(this.userData[0]).indexOf('happy_value')) !== -1)) {
          apiHelper.getResource("/api/tool/happymeter/" + this.meeting_uid).then((data) => {
            this.usersData = data;
            this.parseUsers();
          });
        } else {
          this.parseUsers();
        }
      },

      parseUsers: function() {
        for (let i = 0; i < this.usersData.length; i++) {
          let uid = this.usersData[i]['uid'];
          let happiness = this.usersData[i]['happy_value'];

          if (happiness > 0) {
            this.userHappy[uid] = happiness;
            happiness = this.revertHappiness(happiness);

            let toggles = {
              happy: false,
              neutral: false,
              sad: false
            };
            toggles[happiness] = true;

            // this.$emit('happyMeterToggle', {
            //   toggles: toggles,
            //   userid: uid
            // });
          }
        }
        this.dataLoaded = true;
      },


      setHappiness: function(value) {
        let vm = this;
        let happiness = Number(vm.userHappy[value]);
        let uid = value;
        let data_to_send = {
          "value" : {
            [uid]: happiness
          }
        };

        apiHelper.putResource("/api/tool/happymeter/" + vm.meeting_uid, data_to_send).then((data) => {
          vm.userHappy[uid] = happiness;
        });
      },

      isActive: function (item, uid) {
        return Number(item) === this.userHappy[uid];
      },

      changeSmiley: function(user, smileyType){
        let toggles = {
          happy: false,
          neutral: false,
          sad: false
        };
        toggles[smileyType] = true;
        this.$emit('happyMeterToggle', {
          toggles: toggles,
          userid: user
        });

        this.userHappy[user] = this.convertHappiness(smileyType);

        let data_to_send = {
          "value" : {
            [user]: this.convertHappiness(smileyType)
          }
        };

        apiHelper.putResource("/api/tool/happymeter/" + this.meeting_uid, data_to_send).then((data) => {

        });
      },
      convertHappiness: function (happiness) {
        return ['sad', 'neutral', 'happy'].indexOf(happiness) + 1;
      },
      revertHappiness: function (val) {
        let labels = ['sad', 'neutral', 'happy'];
        return labels[val - 1];
      }
    },
    beforeDestroy(){
      let happyAttendees = [];
      for (let i = 0; i < this.attendees.length; i++) {
        happyAttendees.push(this.attendees[i]);
        happyAttendees[i]['happy_value'] = this.userHappy[this.attendees[i].uid];
      }
      this.$parent.meeting_users = happyAttendees;
    },
    watch: {
      userHappy: {
        handler(new_data, old_data) {
          this.isActive(new_data,)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  /*.happy-meter-faces input{*/
  /*-webkit-appearance:none;*/
  /*-moz-appearance:none;*/
  /*}*/

  /*[type="radio"] + label:before, [type="radio"] + label:after {*/
  /*content: none !important;*/
  /*}*/

  .unhappy {
    background-image: url("../assets/img/happy1-selected.svg");
  }

  .neutal {
    background-image: url("../assets/img/happy2-selected.svg");
  }

  .happy {
    background-image: url("../assets/img/happy3-selected.svg");
  }

  .face-label {
    cursor: pointer;
    background-size: contain !important;
    background-repeat: no-repeat;
    display: inline;
    -webkit-filter: brightness(1.8) grayscale(1) opacity(.7);
    filter: brightness(1.8) grayscale(1) opacity(.7);
  }

  .face-label:hover {
    -webkit-filter: grayscale(.5) opacity(.9);
    filter: grayscale(.5) opacity(.9);
  }

  .user-name-row > h6{
    margin-left: 16px;
  }
</style>




// WEBPACK FOOTER //
// src/components/HappyMeterWidget.vue